export default {
  addOns: 'Ti\u1ec7n \u00edch b\u1ed5 sung',
  all: 'Tất cả',
  browse: 'Duyệt',
  buyTickets: 'Mua v\u00e9',
  countSelected: 'Đã chọn {{count}}',
  joinWaitlist: 'Tham gia danh s\u00e1ch ch\u1edd',
  joining: '\u0110ang tham gia',
  salesEnded: '\u0110\u00e3 h\u1ebft h\u1ea1n b\u00e1n',
  schedule: 'Lịch trình',
  soldOut: 'H\u1ebft v\u00e9',
  tickets: 'V\u00e9',
  noDatesAvailable: 'Kh\u00f4ng c\u00f3 ng\u00e0y tr\u1ed1ng',
  seeMoreDates: 'Xem th\u00eam ng\u00e0y',
  about: 'Gi\u1edbi thi\u1ec7u',
  agenda: 'Ch\u01b0\u01a1ng tr\u00ecnh',
  menu: 'Th\u1ef1c \u0111\u01a1n',
  included: 'Bao g\u1ed3m',
  viewMore: 'Xem th\u00eam',
  viewLess: 'Thu g\u1ecdn',
  location: '\u0110\u1ecba \u0111i\u1ec3m',
  time: 'Th\u1eddi gian',
  at: 'l\u00fac',
  noTimesAvailableOnThisDateFotThisPartySize:
    'Kh\u00f4ng c\u00f3 gi\u1edd tr\u1ed1ng cho ng\u00e0y n\u00e0y v\u1edbi s\u1ed1 l\u01b0\u1ee3ng nh\u00f3m n\u00e0y',
  availableTimes: 'Gi\u1edd c\u00f3 s\u1eb5n',
  waitlist: 'Danh s\u00e1ch ch\u1edd',
  continue: 'Ti\u1ebfp t\u1ee5c',
  ticketsAreNoLongerAvailable: 'V\u00e9 kh\u00f4ng c\u00f2n c\u00f3 s\u1eb5n.',
  checkOutOutOtherExperiences:
    'Kh\u00e1m ph\u00e1 c\u00e1c tr\u1ea3i nghi\u1ec7m kh\u00e1c!',
  viewExperiences: 'Xem tr\u1ea3i nghi\u1ec7m',
  from: 't\u1eeb',
  cancellationPolicy: 'Ch\u00ednh s\u00e1ch h\u1ee7y',
  rsvp: 'RSVP',
  nights: '\u0111\u00eam',
  request: 'Y\u00eau c\u1ea7u',
  arrival: '\u0110\u1ebfn',
  departure: '\u0110i',
};
